import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { MdOutlineClose } from "react-icons/md";
import { Button, Divider } from "semantic-ui-react";

const CommonPopModal = ({ openModal, setOpenModal, title, children }) => {
  const { t } = useTranslation();
  const i18n_deposit = (key) => t(`deposit.${key}`);

  return (
    <section className="fixed top-0 left-0 w-full h-full z-[9999999] box-shadow bg-[rgb(0,0,0,0.7)] flex items-center justify-center px-common-padding-x">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
        className="w-full relative md:w-[500px] h-[80vh] rounded-[5px] px-common-padding-x dark:text-base-light-white bg-base-white dark:bg-base-dark"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <MdOutlineClose
          onClick={() => {
            setOpenModal(false);
          }}
          className="absolute top-[5px] right-[5px] text-3xl cursor-pointer"
        />
        <div className="flex items-center justify-center py-[15px] w-full">
          <span className="text-main-color text-xl font-medium">{title}</span>
        </div>
        <Divider className="!my-[0px]" />
        <div className="overflow-y-scroll no-scrollbar h-[calc(100%-130px)]">
          {children}
        </div>
        <Divider className="!my-[0px]" />
        <div className="flex gap-[5px] h-[70px] w-full items-center justify-center">
          <Button
            type="button"
            size="xl"
            className="!bg-main-color !text-white "
            onClick={() => {
              setOpenModal(false);
            }}
          >
            {i18n_deposit("iUnderstand")}{" "}
          </Button>
        </div>
      </motion.div>
    </section>
  );
};

export default CommonPopModal;
